import generatePalette from './generate-palette';
import constants from '../constants';
import converters from '../converters';
import HSLColor from '../classes/hsl-color';

const { GOLDEN_PALETTES, TOLERANCE } = constants;
const generateDarkPalette = (hslColor) => {
  const { hsl2rgb } = converters;
  return {
    1000: new HSLColor(0, 0, 0),
    ...generatePalette(
      hsl2rgb(hslColor),
      GOLDEN_PALETTES.DARK,
      TOLERANCE.DEFAULT_LIGHTNESS,
      TOLERANCE.DEFAULT_CHROMA
    ),
  };
};

export default generateDarkPalette;
